import { render, staticRenderFns } from "./ModalContentInboxMembers.vue?vue&type=template&id=204b3a4b&scoped=true&"
import script from "./ModalContentInboxMembers.vue?vue&type=script&lang=js&"
export * from "./ModalContentInboxMembers.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentInboxMembers.vue?vue&type=style&index=0&id=204b3a4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b3a4b",
  null
  
)

export default component.exports